
import * as Swiper from 'swiper/js/swiper.js';

export default class initSliderImgLegends{
    constructor() {

        this.slider = document.querySelectorAll('.js-slider-img-legends');
        if (this.slider === null) return;

        Array.prototype.forEach.call(this.slider, (slider) => {
            this.initSlider(slider);
        });

    }

    initSlider(slider) {
        let btnNext = slider.querySelector('.legend-swiper-button-next');

        let btnPrev = slider.querySelector('.legend-swiper-button-prev');

        let pagination = slider.querySelector('.swiper-pagination');

        new Swiper(this.slider, {
            slidesPerView: 'auto',
            spaceBetween: 18,
            direction: 'horizontal',
            speed: 500,
            loop: false,
            navigation: {
                nextEl: btnNext,
                prevEl: btnPrev,
            },
            pagination: {
                clickable: true,
                el: pagination,
            
                pagination: '.swiper-pagination',
                type: 'fraction'
            },
        });
    }


}